import '../../../../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../../../../node_modules/lit-html/lit-html.js';
import '../../../../../node_modules/lit-element/lit-element.js';
import Plyr from '../../../../../node_modules/plyr/dist/plyr.min.js';

const localControlsSvg = x `<svg style="display:none"><symbol id="play-icon" viewBox="0 0 37 49"><path d="M0.326416 44.5463V3.64652C0.326416 0.847562 3.46835 -0.801053 5.77153 0.7894L35.3856 21.2393C37.3845 22.6196 37.3845 25.5732 35.3856 26.9535L5.77153 47.4035C3.46835 48.9939 0.326416 47.3453 0.326416 44.5463Z" fill="#EAEAEA"/></symbol><symbol id="pause-icon" viewBox="0 0 20 20"><path d="M6 1H3c-.6 0-1 .4-1 1v14c0 .6.4 1 1 1h3c.6 0 1-.4 1-1V2c0-.6-.4-1-1-1zm6 0c-.6 0-1 .4-1 1v14c0 .6.4 1 1 1h3c.6 0 1-.4 1-1V2c0-.6-.4-1-1-1h-3z"></path></symbol><symbol id="stop-icon" viewBox="0 0 16 16"><rect x=".5" y="2" width="11" height="11" rx=".71" ry=".71"/></symbol><symbol id="volume-icon" viewBox="0 0 54 49"><g clip-path="url(#clip0_219_20261)"><path fill-rule="evenodd" clip-rule="evenodd" d="M37.9771 32.9334C37.0587 32.015 37.0587 30.4997 37.9771 29.5354C40.7782 26.7343 40.7782 22.2341 37.9771 19.433C37.0587 18.5147 37.0587 16.9993 37.9771 16.035C38.8955 15.1166 40.4109 15.1166 41.3752 16.035C46.0131 20.6729 46.0131 28.2496 41.3752 32.8875C40.4568 33.8518 38.9414 33.8518 37.9771 32.9334Z" fill="#EAEAEA"/><path fill-rule="evenodd" clip-rule="evenodd" d="M44.1304 39.0871C43.2121 38.1687 43.2121 36.6533 44.1304 35.689C50.2837 29.5358 50.2837 19.4794 44.1304 13.2802C43.2121 12.3618 43.2121 10.8465 44.1304 9.88216C45.0488 8.96376 46.5642 8.96376 47.5285 9.88216C55.5645 17.9181 55.5645 31.0052 47.5285 39.0412C46.6101 40.0055 45.0948 40.0055 44.1304 39.0871Z" fill="#EAEAEA"/><path fill-rule="evenodd" clip-rule="evenodd" d="M31.4103 44.7813V3.08615C31.4103 1.43304 30.5838 0.514648 29.3899 0.514648C28.8848 0.514648 28.3337 0.652408 27.7827 1.01977L22.5938 5.33622L13.4557 12.913H2.89419C1.56252 12.913 0.460449 14.015 0.460449 15.3467V24.5307V33.8524C0.460449 35.184 1.56252 36.2861 2.89419 36.2861H13.6853L23.9713 44.7813L27.8286 47.9497C28.4256 48.2712 28.9766 48.4548 29.4358 48.4548C30.6297 48.4548 31.4563 47.4905 31.4563 45.8833L31.4103 44.7813Z" fill="#EAEAEA"/></g></symbol><symbol id="muted-icon" viewBox="0 0 48 49"><g clip-path="url(#clip0_219_20301)"><path d="M46.8118 43.1561L4.88713 1.23135C3.73914 0.0833616 1.94827 -0.0084779 0.938035 1.00176C-0.0721986 2.01199 0.0196409 3.80286 1.16763 4.95085L43.0923 46.8755C44.2403 48.0235 46.0312 48.1154 47.0414 47.1051C48.0976 46.0949 48.0057 44.304 46.8118 43.1561Z" fill="#EAEAEA"/><path d="M2.68399 12.7119C1.35232 12.7119 0.250244 13.814 0.250244 15.1457V33.6513C0.250244 34.983 1.35232 36.085 2.68399 36.085H13.4751L23.7611 44.5802L27.6184 47.7487C28.2154 48.0701 28.7205 48.2538 29.2256 48.2538C30.4195 48.2538 31.2461 47.2895 31.2461 45.6823V40.3005L3.65749 12.7119H2.68399Z" fill="#EAEAEA"/><path d="M31.2458 20.0599V2.88596C31.2458 1.23285 30.4192 0.314453 29.2253 0.314453C28.7202 0.314453 28.1692 0.452212 27.6181 0.81957L22.4292 5.13602L17.75 8.99328L31.2458 22.4891V20.0599Z" fill="#EAEAEA"/></g></symbol><symbol id="audio-description-icon" viewBox="0 0 104 42"><path d="M40.3536 41.8221H30.5857V35.6171H17.5443L13.8081 41.8221H0.424805L1.23451 40.6637L15.2604 20.0028L28.5036 0.459475L34.4415 0.432218H40.3536V41.8221ZM31.0099 14.2011L26.7428 20.8342L22.4797 27.4849L26.7171 27.5708C27.6811 27.5708 28.5769 27.5939 29.3095 27.5939C29.4509 27.598 29.6179 27.6035 29.785 27.6035C30.2387 27.6035 30.6847 27.5858 31.1255 27.5449L31.0651 27.549C31.1165 27.4944 31.1255 24.9772 31.0908 20.8124L31.0099 14.2025V14.2011ZM51.7281 41.8221H43.6991V0.432218H52.0057C52.7987 0.391333 53.7279 0.368164 54.6662 0.368164C57.2791 0.368164 59.8496 0.554875 62.3687 0.913306L62.0731 0.876509C66.8799 2.08945 70.7575 5.52794 72.7406 10.0894L72.7792 10.1944C74.2277 13.0018 75.0798 16.3449 75.0798 19.902C75.0798 20.3885 75.0631 20.8696 75.0322 21.3466L75.0361 21.2825C75.0528 21.6096 75.0656 21.9953 75.0656 22.3865C75.0656 24.4212 74.77 26.3796 74.2174 28.2195L74.2521 28.0832C73.0658 33.2212 69.9426 37.4188 65.7733 39.831L65.6833 39.876C62.3378 41.6068 60.7737 41.8249 51.7255 41.8249V41.8208L51.7281 41.8221ZM52.9015 10.3892V31.5312L56.612 31.4127C60.8701 31.2627 61.9163 30.8716 63.6128 28.7823C65.0356 26.9875 65.9005 24.6488 65.9005 22.1003C65.9005 21.705 65.8787 21.3139 65.8401 20.9282L65.844 20.9732C65.8915 20.6188 65.9172 20.21 65.9172 19.7916C65.9172 18.3919 65.6126 17.07 65.069 15.8938L65.0908 15.9442C63.2568 11.7603 61.7068 10.8022 56.364 10.5337L52.8938 10.3879H52.9028L52.9015 10.3892ZM97.1526 41.7949C96.7413 41.7949 96.5486 41.754 96.4882 41.6586C96.4277 41.5632 96.4882 41.4678 96.5306 41.322C98.6988 35.3254 99.9712 28.3926 100.017 21.1517V21.1285C99.9442 13.8604 98.6718 6.92759 96.402 0.518078L96.5306 0.936475C96.4702 0.777021 96.4625 0.687072 96.5049 0.61893C96.6038 0.464927 96.9933 0.432218 98.0343 0.432218C99.38 0.432218 99.7694 0.541247 99.984 0.995078C101.008 3.9661 101.89 7.51362 102.474 11.1661L102.521 11.534C102.98 14.4192 103.241 17.7391 103.241 21.1245C103.241 27.5708 102.294 33.7758 100.542 39.6048L100.654 39.1728L99.8735 41.6845L98.0909 41.7758C97.65 41.7853 97.3673 41.799 97.1526 41.799V41.7949ZM79.0216 41.7949C78.7864 41.7949 78.5294 41.7949 78.1862 41.7676L76.3187 41.6763L77.3212 40.0818C79.8146 36.0477 81.5407 31.2546 82.1795 26.0948L82.1962 25.9217C82.3157 24.6038 82.3851 23.0774 82.3851 21.5292C82.3851 18.4587 82.1191 15.4509 81.605 12.5344L81.6474 12.8342C80.6063 8.36404 78.9008 4.43901 76.6311 0.959643L76.7043 1.07821L76.2583 0.42813H80.2169L80.9714 1.67242C82.407 4.29864 83.6151 7.33236 84.4505 10.531L84.5109 10.8076C85.3168 13.8782 85.7743 17.4079 85.7743 21.0522C85.7743 27.2573 84.4338 33.1312 82.0432 38.3646L82.1422 38.1288C80.668 41.3083 80.429 41.7949 79.0152 41.7949H79.0242H79.0216ZM87.6932 41.7949C87.6071 41.8044 87.5133 41.8126 87.4143 41.8126C87.1354 41.8126 86.8655 41.7676 86.6136 41.6763L86.6303 41.6804C86.6303 41.5714 87.2087 40.2767 87.4657 39.7274C88.0222 38.5458 88.5877 37.1067 89.0684 35.6212L89.1417 35.3663C90.4102 31.1782 91.1377 26.3578 91.1377 21.3561C91.1377 14.5555 89.7882 8.09147 87.3552 2.24482L87.467 2.54873C87.2138 1.9995 86.6316 0.708878 86.6316 0.595761C86.8719 0.509901 87.1457 0.459475 87.4284 0.459475C87.5223 0.459475 87.6122 0.463564 87.7022 0.473104H87.6893C87.9464 0.473104 88.2202 0.473104 88.4952 0.500361L90.3627 0.586221L91.4204 3.38008C93.3136 8.64479 94.4112 14.7368 94.4112 21.0972C94.4112 27.4576 93.2121 34.1084 91.031 39.9414L91.1467 39.5966L90.3755 41.6545L88.508 41.7458C88.2343 41.7458 87.9644 41.769 87.7022 41.769L87.6932 41.7963V41.7949Z" fill="white"/></symbol><symbol id="captions-icon" viewBox="0 0 55 48"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.673096 7.17939C0.673096 3.4422 3.70269 0.412598 7.43988 0.412598H48.1787C51.9159 0.412598 54.9455 3.44219 54.9455 7.17938V41.0133C54.9455 44.7505 51.9159 47.7801 48.1787 47.7801H7.43988C3.70269 47.7801 0.673096 44.7505 0.673096 41.0133V7.17939ZM36.8543 13.9453H42.8846C44.5498 13.9453 45.8997 15.4601 45.8997 17.3287C45.8997 19.1973 44.5498 20.7121 42.8846 20.7121H39.8694C38.2042 20.7121 36.8543 22.2269 36.8543 24.0955C36.8543 25.9641 38.2042 27.4789 39.8694 27.4789H42.8846C44.5498 27.4789 45.8997 28.9937 45.8997 30.8623C45.8997 32.7309 44.5498 34.2457 42.8846 34.2457H36.8543C33.5239 34.2457 30.8241 31.2161 30.8241 27.4789V20.7121C30.8241 16.9749 33.5239 13.9453 36.8543 13.9453ZM21.7784 13.9453H15.7482C12.4177 13.9453 9.71789 16.9749 9.71789 20.7121V27.4789C9.71789 31.2161 12.4177 34.2457 15.7482 34.2457H21.7784C23.4436 34.2457 24.7935 32.7309 24.7935 30.8623C24.7935 28.9937 23.4436 27.4789 21.7784 27.4789H18.7633C17.0981 27.4789 15.7482 25.9641 15.7482 24.0955C15.7482 22.2269 17.0981 20.7121 18.7633 20.7121H21.7784C23.4436 20.7121 24.7935 19.1973 24.7935 17.3287C24.7935 15.4601 23.4436 13.9453 21.7784 13.9453Z" fill="#EAEAEA"/></symbol><symbol id="transcription-icon" viewBox="0 0 56 44"><g clip-path="url(#clip0_541_51148)"><path d="M48.8083 0.29248H7.88992C3.9671 0.29248 0.773682 3.42351 0.773682 7.26971V36.9229C0.773682 40.7691 3.9671 43.9002 7.88992 43.9002H48.8083C52.7311 43.9002 55.9246 40.7691 55.9246 36.9229V7.26971C55.9246 3.42351 52.7311 0.29248 48.8083 0.29248ZM52.3664 36.9229C52.3664 38.8504 50.7742 40.4115 48.8083 40.4115H7.88992C5.92406 40.4115 4.3318 38.8504 4.3318 36.9229V7.26971C4.3318 5.34225 5.92406 3.78109 7.88992 3.78109H48.8083C50.7742 3.78109 52.3664 5.34225 52.3664 7.26971V36.9229Z" fill="white"/><path d="M10.5586 28.2005H14.1167C15.0952 28.2005 15.8958 27.4156 15.8958 26.4562C15.8958 25.4969 15.0952 24.7119 14.1167 24.7119H10.5586C9.58012 24.7119 8.77954 25.4969 8.77954 26.4562C8.77954 27.4156 9.58012 28.2005 10.5586 28.2005Z" fill="white"/><path d="M46.1399 24.7119H20.3435C19.365 24.7119 18.5645 25.4969 18.5645 26.4562C18.5645 27.4156 19.365 28.2005 20.3435 28.2005H46.1399C47.1184 28.2005 47.919 27.4156 47.919 26.4562C47.919 25.4969 47.1184 24.7119 46.1399 24.7119Z" fill="white"/><path d="M46.1394 32.562H42.5813C41.6028 32.562 40.8022 33.3469 40.8022 34.3063C40.8022 35.2657 41.6028 36.0506 42.5813 36.0506H46.1394C47.1179 36.0506 47.9185 35.2657 47.9185 34.3063C47.9185 33.3469 47.1179 32.562 46.1394 32.562Z" fill="white"/><path d="M36.355 32.562H10.5586C9.58012 32.562 8.77954 33.3469 8.77954 34.3063C8.77954 35.2657 9.58012 36.0506 10.5586 36.0506H36.355C37.3335 36.0506 38.134 35.2657 38.134 34.3063C38.134 33.3469 37.3335 32.562 36.355 32.562Z" fill="white"/></g></symbol><symbol id="theater-icon" viewBox="0 0 62 48"><path fill-rule="evenodd" clip-rule="evenodd" d="M61.0553 0.412598H0.752686V47.7801H61.0553V0.412598ZM55.0257 7.17864H6.78357V41.0126H55.0257V7.17864Z" fill="#EAEAEA"/></symbol><symbol id="fullscreen-icon" viewBox="0 0 50 55"><path d="M49.1254 0.0292969H31.0346V6.79608H43.0951V20.3296H49.1254V0.0292969Z" fill="#EAEAEA"/><path d="M49.1254 33.8632H43.0951V47.3968H31.0346V54.1636H49.1254V33.8632Z" fill="#EAEAEA"/><path d="M6.91356 20.3296V6.79608H18.9741V0.0292969H0.883301V20.3296H6.91356Z" fill="#EAEAEA"/><path d="M0.883301 33.8632V54.1636H18.9741V47.3968H6.91356V33.8632H0.883301Z" fill="#EAEAEA"/></symbol><symbol id="overlay-play-icon" viewBox="0 0 32 40"><path d="M29.4355 20.3104L30.4376 18.79C30.9488 19.1269 31.2564 19.6982 31.2564 20.3104C31.2564 20.9226 30.9488 21.4939 30.4376 21.8308L29.4355 20.3104ZM3.73013 39.4334C2.89042 39.9869 1.76104 39.7548 1.2076 38.9151C0.654155 38.0754 0.886218 36.946 1.72593 36.3926L3.73013 39.4334ZM2.72803 2.70776L0.907066 2.70776C0.907066 2.03792 1.27482 1.42216 1.86457 1.10453C2.45432 0.786911 3.17084 0.818713 3.73013 1.18734L2.72803 2.70776ZM4.54899 20.3104L4.54899 22.1314L0.907064 22.1314L0.907065 20.3104L4.54899 20.3104ZM30.4376 21.8308L3.73013 39.4334L1.72593 36.3926L28.4334 18.79L30.4376 21.8308ZM28.4334 21.8308L1.72593 4.22819L3.73013 1.18734L30.4376 18.79L28.4334 21.8308ZM4.54899 2.70776L4.54899 20.3104L0.907065 20.3104L0.907066 2.70776L4.54899 2.70776Z"/><defs xmlns="http://www.w3.org/2000/svg"><linearGradient id="paint0_linear_1600_334" x1="2.72803" y1="2.70776" x2="7.81136" y2="40.7988" gradientUnits="userSpaceOnUse"><stop stop-color="#702595"/><stop offset="1" stop-color="#AA0061"/></linearGradient></defs></symbol><symbol id="more-icon" viewBox="0 0 24 24"><circle cx="12" cy="12" r="1.5"/><circle cx="12" cy="5" r="1.5"/><circle cx="12" cy="19" r="1.5"/></symbol></svg>`;
const parseTime = (time) => {
    const [hours, minutes, seconds] = time
        .split(':')
        .map(part => parseFloat(part));
    return hours * 3600 + minutes * 60 + seconds;
};
const formatTime = (time) => {
    const parts = time.split(':');
    const minutes = parts[1];
    const seconds = parts[2].split('.')[0];
    return `${minutes}:${seconds}`;
};
const syncAudioDescription = (component) => {
    const audio = component.renderRoot.querySelector('#audio-description');
    const video = component.renderRoot.querySelector('#player');
    if (!audio || !video) {
        console.error('Audio or video element not found');
        return;
    }
    audio.load();
    const isPlaying = !video.paused && !video.ended && video.readyState > 2;
    const videoCurrentTime = video.currentTime;
    if (videoCurrentTime > 0) {
        audio.currentTime = videoCurrentTime;
    }
    if (isPlaying && component.showAudioDescription === true) {
        audio.play().catch(e => {
            console.error('Error playing audio description:', e);
        });
    }
    const syncHandler = () => {
        if (component.showAudioDescription) {
            audio.currentTime = video.currentTime;
            if (!video.paused) {
                audio.play().catch(e => console.error('Audio play error:', e));
            }
            else {
                audio.pause();
            }
        }
    };
    video.removeEventListener('play', syncHandler);
    video.removeEventListener('pause', syncHandler);
    video.removeEventListener('seeked', syncHandler);
    video.addEventListener('play', syncHandler);
    video.addEventListener('pause', syncHandler);
    video.addEventListener('seeked', syncHandler);
    video.addEventListener('volumechange', () => {
        audio.muted = video.muted;
        audio.volume = video.volume;
    });
};
const handleStop = (component) => {
    const currentComponent = component;
    const stopButton = currentComponent.renderRoot.querySelector('.stop-button');
    stopButton === null || stopButton === void 0 ? void 0 : stopButton.addEventListener('click', () => {
        currentComponent.player.stop();
        currentComponent.player.currentTime = 0;
    });
};
const removeAudioDescription = (component) => {
    const audio = component.renderRoot.querySelector('#audio-description');
    const video = component.renderRoot.querySelector('#player');
    if (component.showAudioDescription === false) {
        audio.pause();
        video.removeEventListener('pause', () => {
            audio.pause();
        });
        video.removeEventListener('play', () => {
            audio.play();
        });
        video.removeEventListener('seeked', () => {
            audio.currentTime = video.currentTime;
        });
        video.removeEventListener('volumechange', () => {
            audio.muted = true;
        });
    }
};
const ARIA_PRESSED = 'aria-pressed';
const pressedStyle = 'plyr__control--pressed';
const toggleAudioDescription = async (component) => {
    const currentComponent = component;
    currentComponent.showAudioDescription =
        !currentComponent.showAudioDescription;
    const button = currentComponent.renderRoot.querySelector('#audio-description-button');
    if (!button) {
        console.error('Audio description button not found');
        return;
    }
    if (currentComponent.showAudioDescription) {
        button.classList.add(pressedStyle);
        button.setAttribute(ARIA_PRESSED, 'true');
        await currentComponent.updateComplete;
        syncAudioDescription(component);
    }
    else {
        button.classList.remove(pressedStyle);
        button.setAttribute(ARIA_PRESSED, 'false');
        await currentComponent.updateComplete;
        removeAudioDescription(component);
    }
};
const renderAudioDescription = (component) => {
    var _a;
    const { audioDescription } = component;
    if (!audioDescription) {
        console.log('No audio description URL provided');
        return null;
    }
    console.log('Audio description URL:', audioDescription);
    console.log('Audio description language:', component.audioDescriptionLang);
    return x `<audio id="audio-description" src="${audioDescription}" lang="${(_a = component.audioDescriptionLang) !== null && _a !== void 0 ? _a : 'en'}" @loadstart="${() => console.log('Audio loading started')}" @loadeddata="${() => console.log('Audio data loaded')}" @error="${(e) => {
        const audio = e.target;
        console.error('Audio loading error:', audio.error);
    }}"></audio>`;
};
const handleADStateChange = (adState, component) => {
    if (adState) {
        renderAudioDescription(component);
    }
};
const handleAudioDescriptionButton = (component) => {
    const audioDescriptionButton = component.renderRoot.querySelector('#audio-description-button');
    if (!audioDescriptionButton) {
        console.error('Audio description button not found in shadow DOM');
        return;
    }
    audioDescriptionButton.addEventListener('click', async (e) => {
        e.preventDefault();
        e.stopPropagation();
        console.log('Audio description button clicked');
        await toggleAudioDescription(component);
    });
};
const toggleTheaterMode = async (component) => {
    const currentComponent = component;
    currentComponent.theaterMode = !currentComponent.theaterMode;
    const button = component.renderRoot.querySelector('#theater-button');
    const buttonClasses = button === null || button === void 0 ? void 0 : button.classList;
    const videoWrapper = component.renderRoot.querySelector('.video-player-wrapper');
    if (buttonClasses === null || buttonClasses === void 0 ? void 0 : buttonClasses.contains(pressedStyle)) {
        button === null || button === void 0 ? void 0 : button.classList.remove(pressedStyle);
        button === null || button === void 0 ? void 0 : button.setAttribute(ARIA_PRESSED, 'false');
        videoWrapper.classList.remove('video-player-wrapper--theater');
        const closeButton = videoWrapper.querySelector('.theater-close-button');
        if (closeButton) {
            videoWrapper.removeChild(closeButton);
        }
        document.body.style.overflow = '';
        await component.updateComplete;
    }
    else {
        button === null || button === void 0 ? void 0 : button.classList.add(pressedStyle);
        button === null || button === void 0 ? void 0 : button.setAttribute(ARIA_PRESSED, 'true');
        videoWrapper.classList.add('video-player-wrapper--theater');
        const closeButton = document.createElement('button');
        closeButton.classList.add('theater-close-button');
        closeButton.innerHTML = '✕';
        closeButton.setAttribute('aria-label', 'Exit theater mode');
        closeButton.addEventListener('click', () => {
            toggleTheaterMode(component);
        });
        videoWrapper.appendChild(closeButton);
        document.body.style.overflow = 'hidden';
        await component.updateComplete;
    }
};
const handleTheaterButton = (component) => {
    const TheaterButton = component.renderRoot.querySelector('#theater-button');
    TheaterButton === null || TheaterButton === void 0 ? void 0 : TheaterButton.addEventListener('click', async () => {
        toggleTheaterMode(component);
        await component.updateComplete;
    });
};
const syncTranscription = (component) => {
    const video = component.renderRoot.querySelector('#player');
    const activeLine = 'transcript-line--active';
    const nextLine = 'transcript-line--next';
    const followsLine = 'transcript-line--follows';
    const disabledLine = 'transcript-line--disabled';
    const transcriptContainer = component.renderRoot.querySelector('.transcript-container');
    const lines = transcriptContainer === null || transcriptContainer === void 0 ? void 0 : transcriptContainer.querySelectorAll('.transcript-line--disabled');
    if (!video)
        return;
    video.addEventListener('timeupdate', () => {
        var _a, _b, _c, _d, _e, _f;
        const { currentTime } = video;
        const linesArray = Array.from(lines || []);
        const currentIndex = linesArray === null || linesArray === void 0 ? void 0 : linesArray.findIndex((line) => {
            const start = parseTime(line.getAttribute('data-start') || '0:00');
            const end = parseTime(line.getAttribute('data-end') || '0:00');
            return currentTime >= start && currentTime <= end;
        });
        if (currentIndex === -1)
            return;
        linesArray.forEach(line => {
            const classes = line.classList;
            if (classes.contains(activeLine) ||
                classes.contains(nextLine) ||
                classes.contains(followsLine)) {
                line.classList.remove(activeLine);
                line.classList.remove(nextLine);
                line.classList.remove(followsLine);
                line.classList.add(disabledLine);
            }
        });
        (_a = linesArray[currentIndex]) === null || _a === void 0 ? void 0 : _a.classList.remove(disabledLine);
        (_b = linesArray[currentIndex + 1]) === null || _b === void 0 ? void 0 : _b.classList.remove(disabledLine);
        (_c = linesArray[currentIndex + 2]) === null || _c === void 0 ? void 0 : _c.classList.remove(disabledLine);
        (_d = linesArray[currentIndex]) === null || _d === void 0 ? void 0 : _d.classList.add(activeLine);
        (_e = linesArray[currentIndex + 1]) === null || _e === void 0 ? void 0 : _e.classList.add(nextLine);
        (_f = linesArray[currentIndex + 2]) === null || _f === void 0 ? void 0 : _f.classList.add(followsLine);
    });
};
const renderTranscriptionFromCaptions = async (captions, component) => {
    const transcriptContainer = component.renderRoot.querySelector('.transcript-container');
    if (!transcriptContainer)
        return;
    transcriptContainer.innerHTML = '';
    captions.forEach(caption => {
        const div = document.createElement('div');
        div.classList.add('transcript-line');
        div.classList.add('transcript-line--disabled');
        div.setAttribute('data-start', caption.start);
        div.setAttribute('data-end', caption.end);
        const formattedTime = formatTime(caption.start);
        const startSpan = document.createElement('span');
        startSpan.classList.add('transcript-time');
        startSpan.textContent = formattedTime;
        div.appendChild(startSpan);
        div.appendChild(document.createTextNode(` ${caption.text}`));
        transcriptContainer.appendChild(div);
    });
    await component.updateComplete;
    syncTranscription(component);
};
const parseVTT = (vttText) => {
    const captions = [];
    const lines = vttText.split('\n');
    let currentCaption = null;
    for (const line of lines) {
        if (line.includes('-->')) {
            const [start, end] = line.split('-->').map(time => time.trim());
            currentCaption = { start, end, text: '' };
        }
        else if (line.trim() === '') {
            if (currentCaption)
                captions.push(currentCaption);
            currentCaption = null;
        }
        else if (currentCaption) {
            currentCaption.text += `${line.trim()} `;
        }
    }
    return captions;
};
const getTranscription = async (component) => {
    if (!component.closedCaptions)
        return;
    const response = await fetch(component.closedCaptions);
    const vttText = await response.text();
    const parsedCaptions = parseVTT(vttText);
    renderTranscriptionFromCaptions(parsedCaptions, component);
};
const toggleTranscript = async (component) => {
    const currentComponent = component;
    currentComponent.showTranscription = !currentComponent.showTranscription;
    const button = component.renderRoot.querySelector('#transcript-button');
    const buttonClasses = button === null || button === void 0 ? void 0 : button.classList;
    if (buttonClasses === null || buttonClasses === void 0 ? void 0 : buttonClasses.contains(pressedStyle)) {
        button === null || button === void 0 ? void 0 : button.classList.remove(pressedStyle);
        await component.updateComplete;
    }
    else {
        button === null || button === void 0 ? void 0 : button.classList.add(pressedStyle);
        await component.updateComplete;
        getTranscription(component);
    }
};
const renderCaptions = (closedCaptions) => {
    if (!closedCaptions) {
        return x ``;
    }
    return x `<track kind="captions" src="${closedCaptions}">`;
};
const handleTranscriptButton = (component) => {
    const transcriptButton = component.renderRoot.querySelector('#transcript-button');
    transcriptButton === null || transcriptButton === void 0 ? void 0 : transcriptButton.addEventListener('click', async () => {
        toggleTranscript(component);
        await component.updateComplete;
    });
};
const renderTranscription = (component) => {
    if (!component.showTranscription) {
        return null;
    }
    return x `<div class="transcript-container"></div>`;
};
const handleTranscriptionStateChange = (transcriptState, component) => {
    if (transcriptState) {
        renderTranscription(component);
    }
};
const updateTimeDisplay = (component) => {
    const video = component.renderRoot.querySelector('#player');
    const timeDisplay = component.renderRoot.querySelector('.plyr__time--current');
    if (!video || !timeDisplay)
        return;
    const formatTimeValue = (seconds) => {
        const minutes = Math.floor(seconds / 60);
        const secs = Math.floor(seconds % 60);
        return `${minutes}:${secs.toString().padStart(2, '0')}`;
    };
    video.addEventListener('timeupdate', () => {
        const current = formatTimeValue(video.currentTime);
        const total = formatTimeValue(video.duration || 0);
        timeDisplay.textContent = `${current} / ${total}`;
    });
    video.addEventListener('loadedmetadata', () => {
        const current = formatTimeValue(0);
        const total = formatTimeValue(video.duration || 0);
        timeDisplay.textContent = `${current} / ${total}`;
    });
};
const renderLocalVideo = (component) => x `<link rel="stylesheet" href="https://cdn.plyr.io/3.7.8/plyr.css">${localControlsSvg}<video id="player" class="plyr-local-video" playsinline controls><source src="${component.videoId}" type="video/mp4">${renderCaptions(component.closedCaptions)}</video>`;
const initializePlyr = (component) => {
    const currentComponent = component;
    const playerElement = component.renderRoot.querySelector('#player');
    if (!playerElement)
        return;
    const videoTitle = component.videoname
        ? `<p class="plyr__video-title">${component.videoname}</p>`
        : '';
    const audioDescriptionButton = component.audioDescription
        ? `<button id="audio-description-button" type="button" class="plyr__control audio-description-control" data-plyr="audio-description" id="audio-description-button" aria-label="Audio Description" title="Toggle Audio Description">
        <svg class="icon--pressed" role="presentation"><use xlink:href="#audio-description-icon"></use></svg>
        <svg class="icon--not-pressed" role="presentation"><use xlink:href="#audio-description-icon"></use></svg>
      </button>`
        : '';
    const closedCaptionsButton = component.closedCaptions
        ? `<button id="closed-captions-button" type="button" class="plyr__control" data-plyr="captions" aria-label="Captions" title="Toggle Captions">
        <svg class="icon--pressed" role="presentation"><use xlink:href="#captions-icon"></use></svg>
        <svg class="icon--not-pressed" role="presentation"><use xlink:href="#captions-icon"></use></svg>
      </button>`
        : '';
    const TranscriptionButton = component.closedCaptions
        ? `<button type="button" class="plyr__control" id="transcript-button" aria-label="Transcript" title="Toggle Transcript">
        <svg class="icon--pressed" role="presentation"><use xlink:href="#transcription-icon"></use></svg>
        <svg class="icon--not-pressed" role="presentation"><use xlink:href="#transcription-icon"></use></svg>
      </button>`
        : '';
    currentComponent.player = new Plyr(playerElement, {
        controls: `
      <div class="plyr__overlay" style="opacity: 1; visibility: visible;">
        <div class="plyr__overlay-container">
          <button type="button" class="plyr__control plyr__control--overlaid" data-plyr="play" aria-label="Play video">
            <svg class="icon--not-pressed" role="presentation"><use xlink:href="#overlay-play-icon"></use></svg>
          </button>
          ${videoTitle}
        </div>
      </div>
      <div class="plyr__controls">
        <div class="plyr__controls__item plyr__progress__container">
          <input type="range" class="plyr__progress__input" min="0" max="100" step="0.1" value="0" data-plyr="seek" aria-label="Seek"/>
        </div>
        <div class="basic-controls">
          <button type="button" class="plyr__control" data-plyr="play" id="play-button" aria-label="Play/Pause">
            <svg class="icon--pressed" role="presentation"><use xlink:href="#pause-icon"></use></svg>
            <svg class="icon--not-pressed" role="presentation"><use xlink:href="#play-icon"></use></svg>
          </button>
          <button type="button" class="plyr__control stop-button" id="stop-button" aria-label="Stop">
            <svg class="icon--pressed" role="presentation"><use xlink:href="#stop-icon"></use></svg>
            <svg class="icon--not-pressed" role="presentation"><use xlink:href="#stop-icon"></use></svg>
          </button>
          <button id="mute-button" type="button" class="plyr__control" data-plyr="mute" aria-label="Mute/Unmute">
            <svg class="icon--pressed" role="presentation"><use xlink:href="#muted-icon"></use></svg>
            <svg class="icon--not-pressed" role="presentation"><use xlink:href="#volume-icon"></use></svg>
          </button>
          <input type="range" class="plyr__volume__input" min="0" max="1" step="0.1" value="0.8" data-plyr="volume" aria-label="Volume"/>
          <p class="plyr__time plyr__time--current" aria-label="Current time">0:00 / 0:00</p>
          ${audioDescriptionButton}
          ${closedCaptionsButton}
          ${TranscriptionButton}
          <button id="theater-button" type="button" class="plyr__control" data-plyr="theater" aria-label="Theater mode">
            <svg class="icon--pressed" role="presentation"><use xlink:href="#theater-icon"></use></svg>
            <svg class="icon--not-pressed" role="presentation"><use xlink:href="#theater-icon"></use></svg>
          </button>
          <button id="fullscreen-button" type="button" class="plyr__control" data-plyr="fullscreen" aria-label="Fullscreen">
            <svg class="icon--pressed" role="presentation"><use xlink:href="#fullscreen-icon"></use></svg>
            <svg class="icon--not-pressed" role="presentation"><use xlink:href="#fullscreen-icon"></use></svg>
          </button>
        </div>
      </div>
    `,
        hideControls: false,
    });
    // Handle video events for overlay
    const video = component.renderRoot.querySelector('video');
    const overlay = component.renderRoot.querySelector('.plyr__overlay');
    const overlayTransition = 'opacity 0.3s ease, visibility 0.3s ease';
    if (video && overlay) {
        video.addEventListener('play', () => {
            overlay.style.opacity = '0';
            overlay.style.visibility = 'hidden';
            overlay.style.transition = overlayTransition;
        });
        video.addEventListener('pause', () => {
            overlay.style.opacity = '1';
            overlay.style.visibility = 'visible';
            overlay.style.transition = overlayTransition;
        });
        video.addEventListener('ended', () => {
            overlay.style.opacity = '1';
            overlay.style.visibility = 'visible';
            overlay.style.transition = overlayTransition;
            video.currentTime = 0;
        });
    }
    handleAudioDescriptionButton(component);
    handleStop(component);
    handleTheaterButton(component);
    handleTranscriptButton(component);
    updateTimeDisplay(component);
};

export { formatTime, getTranscription, handleADStateChange, handleAudioDescriptionButton, handleStop, handleTheaterButton, handleTranscriptButton, handleTranscriptionStateChange, initializePlyr, localControlsSvg, parseTime, parseVTT, removeAudioDescription, renderAudioDescription, renderCaptions, renderLocalVideo, renderTranscription, renderTranscriptionFromCaptions, syncAudioDescription, syncTranscription, toggleAudioDescription, toggleTheaterMode, toggleTranscript, updateTimeDisplay };
